export class Row<T extends Record<string, any>> {
  key_names: string[];

  declare id: number;

  constructor(props: T) {
    // Use Object.assign to copy all properties from props to this instance
    // This must happen AFTER class field initialization but works correctly
    Object.assign(this, props);

    // Track which keys were passed in
    this.key_names = Object.keys(props);
  }

  toJSON() {
    // Return current instance values, not the original constructor props
    // This ensures any modifications (like anonymization) are reflected
    const result: Record<string, any> = {};
    for (const key of this.key_names) {
      result[key] = (this as any)[key];
    }
    return result;
  }
}
